import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "page",
  class: "snapable"
}
const _hoisted_2 = { class: "actions" }

import SectionContact from "@/components/modules/SectionContact.vue";
import SectionFooter from "@/components/modules/SectionFooter.vue";
import SectionHero from "@/components/modules/SectionHero.vue";
import SectionMethode from "@/components/modules/SectionMethode.vue";
import SectionPartenaires from "@/components/modules/SectionPartenaires.vue";
import SectionServices from "@/components/modules/SectionServices.vue";
import SectionValeurs from "@/components/modules/SectionValeurs.vue";

import CommonButton from "@/components/common/CommonButton.vue";
import CommonSpacer from "@/components/common/CommonSpacer.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const clickHandler = (name: string) => {
    trackButtonClick(`home-hero-${name}`);
    scrollToSection(name);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionHero, null, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("h1", null, [
          _createTextVNode("Révélez le potentiel unique de votre marque pour créer des expériences "),
          _createElementVNode("strong", null, "innovantes"),
          _createTextVNode(", "),
          _createElementVNode("strong", null, "cohérentes"),
          _createTextVNode(" et "),
          _createElementVNode("strong", null, "captivantes"),
          _createTextVNode(". ")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler('services'))),
            title: "Découvrez nos services"
          }, [
            _createVNode(CommonButton, {
              size: "large",
              outlined: true
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Dites m'en plus", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandler('contact'))),
            title: "Contactez-nous"
          }, [
            _createVNode(CommonButton, {
              size: "large",
              icon: "next"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Je me lance", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(SectionServices),
    _createVNode(SectionValeurs),
    _createVNode(SectionMethode),
    _createVNode(CommonSpacer),
    _createVNode(SectionPartenaires),
    _createVNode(SectionContact),
    _createVNode(CommonSpacer),
    _createVNode(SectionFooter, { isHome: true })
  ]))
}
}

})